import React, {Component} from 'react';
import Products from './Products';
import {
  Col,
  Modal,
  ModalBody,
} from 'reactstrap';
import Loader from 'react-loader';
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [], //All the products
      nextProducts: [], //Used to fetch next batch of products
      shouldShowNextPageButton: false, //Hack to determine if Next Page Button should show
      collectionTitle: '',
      loadedInitProducts: false, //When products are first loaded
      loadedProducts: false, //When on home page and new collection is clicked
      loadedFetchProducts: true, //true because don't want to show loader right away
      collectionPath: '',
      modal: false,
    };

  }

  /*
   * Set loadedProducts to false to show spinner when products are loading
   */
  changeLoadedProducts = () => {
    return (previousState, currentProps) => {
      return {...previousState, loadedProducts: false};
    };
  }

  changeFetchLoadedProducts = () => {
    return (previousState, currentProps) => {
      return {...previousState, loadedFetchProducts: false};
    };
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }

  componentDidMount() {
    this.initHome();
  }

  collectionFound(collection_name) {
    for (var i = 0; i < this.props.collections.length; i++) {
      let c = this.props.collections[i];
      if (c.handle == collection_name) {
        return true;
      }
    }
    return false;
  }

  componentWillReceiveProps() {
    //Only grab new products when a different collection is clicked on
    let href = window.location.href.slice(7); //don't include http://
    let path = href.slice(href.lastIndexOf('/') + 1);
    let path_no_collection = '/no-collection';

    let collection = this.state.collectionPath;
    let parsed = collection.slice(collection.lastIndexOf('/') + 1);
    if (parsed === path && !this.props.firstLoad) {
      return false;
    }
    this.initHome();
  }

  initHome = () => {
    this.setState(this.changeLoadedProducts(), () => {
      if (!this.props.collections.length || this.props.noCollection) {
        return;
      }
      if (window.location.href.includes('collections')) {
        let href = window.location.href.slice(7); //don't include http://
        var path = href.slice(href.indexOf('/'));
        let path_no_collection = '/no-collection';

        //Check if user entered in the url an invalid collection e.g.
        // hostname/collections/poop
        let collection_name = path.slice(path.lastIndexOf('/') + 1);
        //Redirect back to home page if collection not found
        if (
          !this.collectionFound(collection_name) &&
          path !== '/' &&
          path !== path_no_collection &&
          this.props.collections.length !== 0
        ) {
          let host = window.location.hostname;
          let port = window.location.port;
          let url =
            port === ''
              ? host + path_no_collection
              : host + ':' + port + path_no_collection;
          path = path_no_collection;
          this.props.history.push(path_no_collection);
        }
        if (path == path_no_collection) {
          this.setState({modal: true});
        }
        //find id of slug
        let slug = window.location.href.slice(
          window.location.href.lastIndexOf('/') + 1,
          window.location.href.length,
        );
        let curr_collection = this.findIdFromSlug(slug);
        if (!curr_collection) {
          return;
        }
        this.grabCollectionProducts(curr_collection.id);
      } else {
        let curr_collection = this.findIdFromSlug('/');
        if (!curr_collection) {
          return;
        }
        this.grabCollectionProducts(curr_collection.id);
      }

      if (this.props.firstLoad) {
        this.props.updateFirstLoad();
      }
    });
  }

  //Grab collection id from slug
  findIdFromSlug = (slug) => {
    return this.props.collections.find(
      function(collection) {
        if (collection.slug == slug) {
          return collection;
        }
      }.bind(this),
    );
  }

  grabCollectionProducts = (id) => {
    this.props.client.collection.fetchWithProducts(id).then(res => {
      this.setState({
        collectionTitle: res.title,
        products: res.products,
        nextProducts: res.products,
        loadedInitProducts: true,
        loadedProducts: true,
        collectionPath: this.props.location.pathname,
      });
      this.shouldFetchNextPage(res.products);
    });
  }

  //Currently there isn't a good way to determine if there are products in the
  //next page, so this is a hacky way to determine if the NEXT PAGE button
  //should show
  shouldFetchNextPage = (products) => {
    this.props.client
      .fetchNextPage(products)
      .then(res => {
        this.setState({
          shouldShowNextPageButton: res.model.length ? true : false,
        });
      })
      .catch(() => {
        this.setState({
          shouldShowNextPageButton: false,
        });
      });
  }

  fetchNextPage = (products) => {
    this.setState(this.changeFetchLoadedProducts(), () => {
      this.props.client.fetchNextPage(products).then(res => {
        this.setState({
          products: this.state.products.concat(res.model),
          nextProducts: res.model,
          loadedFetchProducts: true,
        });
        //Check if should show next page button
        this.shouldFetchNextPage(res.model);
      });
    });
  }

  generateSkeletonList(amount) {
    var list = [];
    return list;
  }

  handleCollectionChange = (event) => {
    let collectionId = event.target.id;
    //  this.grabCollectionProducts(collectionId);
  }

  render() {
    var home_body = (
      <Products
        products={this.state.products}
        addVariantToCart={this.props.addVariantToCart}
        style={this.props.style}
      />
    );
    if (this.props.noCollection) {
      home_body = <h1 style={this.props.style.theme}> No Available Items </h1>;
    }

    //Show Next Pagination Button
    var showNextButton = <div />;
    if (this.state.shouldShowNextPageButton) {
      showNextButton = (
        <Loader
          options={{position: 'relative'}}
          loaded={this.state.loadedFetchProducts}>
          <div>
            <br />
            <span
              className="button Product__next-button"
              style={this.props.style.addToCartButton}
              onClick={() => {
                this.fetchNextPage(this.state.nextProducts);
              }}>
              NEXT PAGE
            </span>
          </div>
        </Loader>
      );
    }

    var showSkeleton = <div />;
    var skeletonList = [];

    for (var i = 0; i < 6; i++) {
      skeletonList.push(
        <div className=" col-md-12 col-lg-6 col-xl-4">
          <div className="Product Product__cont">
            <img src="https://dummyimage.com/314x450/eeeeee/fff.png&text=+" />
          </div>
        </div>,
      );
    }

    if (!this.state.loadedProducts) {
      showSkeleton = <div className="row">{skeletonList}</div>;
    }

    return (
      <div>
        {showSkeleton}
        <Col lg="12">
          <Loader style={this.props.button} loaded={this.state.loadedProducts}>
            <div>{home_body}</div>
            {showNextButton}
          </Loader>
        </Col>
        <Modal
          isOpen={this.state.modal}
          onHide={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}>
          <ModalBody style={this.props.style.bodyBackgroundColor}>
            <br />
            <p style={this.props.style.productDescColor}>
              Sorry, but that collection doesn't exist
            </p>
          </ModalBody>
          <div
            className="Modal__footer"
            style={this.props.style.bodyBackgroundColor}>
            <div
              className="button Modal__preview-button"
              color="primary"
              style={this.props.style.addToCartButton}
              onClick={this.toggle}>
              Okay
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js